import api from "@/lib/api";

export function getDeviceId() {
  let id = localStorage.getItem("slackr_device_id");
  if (!id) {
    id = "dev_" + (window.crypto?.randomUUID?.() || (Math.random().toString(36).slice(2) + Date.now().toString(36)));
    localStorage.setItem("slackr_device_id", id);
  }
  return id;
}

export function detectPlatform() {
  const ua = navigator.userAgent || "";
  if (/android/i.test(ua)) return "android";
  if (/iphone|ipad|ipod/i.test(ua)) return "ios";
  if (/windows/i.test(ua)) return "windows";
  if (/macintosh|mac os x/i.test(ua)) return "macos";
  if (/cros/i.test(ua)) return "chromeos";
  if (/linux/i.test(ua)) return "linux";
  return "web";
}

export function isInstalled() {
  return window.navigator.standalone === true || window.matchMedia("(display-mode: standalone)").matches;
}

let lastRegistered = 0;
export async function registerDevice() {
  const now = Date.now();
  if (now - lastRegistered < 60000) return; // hooguit 1x per minuut
  lastRegistered = now;
  try {
    await api.post("/devices/register", {
      device_id: getDeviceId(),
      platform: detectPlatform(),
      installed: isInstalled(),
      ua: (navigator.userAgent || "").slice(0, 400),
    });
  } catch { /* stil falen; niet blokkerend */ }
}
